import { AnimationSpeed, CasesGamePhases, CasesGameType, PROJECT } from '../../../enums';

export interface ICasesEffectsData {
  project: PROJECT;
  spinState: CasesGamePhases;
  gameType: CasesGameType;
  animationSpeed: AnimationSpeed;
}
